import { httpRequest } from '@/utils/ReqUtil';

export async function validateSession(): Promise<boolean> {
  try {
    const result = await httpRequest<{ valid: boolean }>({
      method: 'GET',
      url: 'users/validate_session',
    });

    return result.valid === true;
  } catch {
    return false;
  }
}
